import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import AdoptionRequestsTable from '@/tables/AdoptionRequestsTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/adoption-requests',
)({
  component: StudentsScreen,
});

function StudentsScreen() {
  const { t } = useTranslation();
  const { groupName } = Route.useParams();
  // Same query and key the `/students` layout guard already issues, so
  // resolving the id here costs no extra request. Deliberately ungated: the
  // tab bar dispatches on group type (`hooks/useStudentTabs.ts:18-26`) and the
  // endpoint's own admin/group-type requirement is the real gate.
  const { data: groupData } = api.getGroupBySlug.useQuery({
    path: { group_slug: groupName },
  });

  return (
    <>
      <GroupHeaderWrapper>
        <TitleWithQuestion title={t('lessons.students')} />
      </GroupHeaderWrapper>
      <AdoptionRequestsTable groupId={groupData?.id} />
    </>
  );
}
